import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { LocalizationProvider } from "@mui/lab";
import { Stack, TextField } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DesktopTimePicker } from "@mui/x-date-pickers/DesktopTimePicker";
import React, { useState } from "react";
import ReactPlayer from "react-player";
import cup from "../../../assets/images/page 1.png";

const MakePostContent = () => {
  const [value, setValue] = React.useState(new Date("2014-08-18T21:11:54"));
  const [title, setTitle] = useState("");
  const [convertedContent, setConvertedContent] = useState(null);
  const [event, setEvent] = useState({});
  const [imageData, setImageData] = useState("");
  const [fileVideo, setFileVideo] = useState("");
  const [file, setFile] = useState("");

  const handleImageChange = (file) => {
    setFile(URL.createObjectURL(file[0]));
    setImageData(file[0]);
  };
  const handleChange = (file) => {
    setFile(URL.createObjectURL(file[0]));
    setImageData(file[0]);
  };
  const handleVideoChange = (file) => {
    setFileVideo(file[0]);
  };

  return (
    <>
      <div className="card card-bg head-line mb-2 mb-2">
        <div className="text-light d-flex p-2">
          <div className="faTrophy">
            <img src={cup} alt="" width="30px" />
          </div>
          <h4 className="mx-3 text-white p-2">Registration Forum for User</h4>
        </div>
      </div>

      <div className="card-bg">
        <div className="container mb-5 mt-4 card-bg py-4">
          <div className="my-2">
            <form id="input_form" encType="multipart/form-data">
              <div className="row ms-5">
                <div className="form-group row my-3">
                  <label
                    for="staticEmail"
                    className="col-sm-2 col-form-label text-light "
                  >
                    Post Title
                  </label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control Frombtns"
                      //   value={title}
                      onChange={(e) => {
                        setTitle(e.target.value);
                      }}
                    />
                  </div>
                </div>

                <div className="form-group row my-3">
                  <label
                    for="inputPassword"
                    className="col-sm-2 col-form-label text-light "
                  >
                    Description
                  </label>
                  <div className="col-sm-9">
                    <CKEditor
                      editor={ClassicEditor}
                      data={event.description}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setConvertedContent(data);
                      }}
                    />
                  </div>
                </div>

                <div className="form-group row my-3">
                  <label
                    for="staticEmail"
                    className="col-sm-2 col-form-label text-light "
                  >
                    Registration Fees
                  </label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control Frombtns "
                    //   value={title}
                    />
                  </div>
                </div>


                <div className="row mt-3">
                  <div className="col-md-6 row">
                    <div className="col-md-4">
                      <label for="staticEmail" className="col-form-label text-light fw-bold">
                        Registration Start Date
                      </label>

                    </div>
                    <div className="col-md-6 ms-1 dateParentPicker timeLengthPicker">
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Stack spacing={3}>
                          <DatePicker
                            disableFuture
                            label="Start Date"
                            openTo="year"
                            views={["year", "month", "day"]}
                            value={value}
                            onChange={(newValue) => {
                              setValue(newValue);
                            }}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </Stack>
                      </LocalizationProvider>
                    </div>
                  </div>
                  <div className="col-md-6 row">
                    <div className="col-md-4">
                      <label for="staticEmail" className="col-form-label text-light fw-bold">
                        Registration End Date
                      </label>

                    </div>
                    <div className="col-md-6 ms-1 dateParentPicker timeLengthPicker">
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Stack spacing={3}>
                          <DatePicker
                            disableFuture
                            label="Responsive"
                            openTo="year"
                            views={["year", "month", "day"]}
                            value={value}
                            onChange={(newValue) => {
                              setValue(newValue);
                            }}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </Stack>
                      </LocalizationProvider>
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-md-6 row">
                    <div className="col-md-4">
                      <label for="staticEmail" className="col-form-label text-light fw-bold">
                      Star Confirmation Date
                      </label>

                    </div>
                    <div className="col-md-6 ms-1 dateParentPicker timeLengthPicker">
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Stack spacing={3}>
                          <DatePicker
                            disableFuture
                            label="Date"
                            openTo="year"
                            views={["year", "month", "day"]}
                            value={value}
                            onChange={(newValue) => {
                              setValue(newValue);
                            }}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </Stack>
                      </LocalizationProvider>
                    </div>
                  </div>
                  <div className="col-md-6 row">
                    <div className="col-md-4">
                      <label for="staticEmail" className="col-form-label text-light fw-bold">
                      Star Confirmation Time
                      </label>

                    </div>
                    <div className="col-md-6 ms-1 dateParentPicker timeLengthPicker">
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Stack spacing={3}>
                          <DesktopTimePicker
                            label="Time"
                            value={value}
                            onChange={(newValue) => {
                              setValue(newValue);
                            }}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </Stack>
                      </LocalizationProvider>
                    </div>
                  </div>
                </div>

                <div className="row justify-content-center my-5">
                  <div className="col-md-3 text-left">
                    <button className="btn btn-warning px-4 fw-bold" type="submit">
                      Publish Request For Manager Admin
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>

        </div>
      </div>
    </>
  );
};

export default MakePostContent;
